import React from 'react';
import clsx from 'clsx';
import { CloseIconContainer } from './Component.style';

import { ReactComponent as CrossIcon } from 'assert/images/Common/cross.svg';
import { ReactComponent as BackArrow } from 'assert/images/Common/backArrow.svg';

const CloseIcon = ({ onClick, customStyle, iconType }) => {
  if (iconType === 'back') {
    return (
      <CloseIconContainer
        className={clsx(customStyle, 'close-icon-container')}
        onClick={onClick}
      >
        <BackArrow />
      </CloseIconContainer>
    );
  }
  return (
    <CloseIconContainer
      className={clsx(customStyle, 'close-icon-container')}
      onClick={onClick}
    >
      <CrossIcon />
    </CloseIconContainer>
  );
};

export default CloseIcon;
